export default __webpack_public_path__ + "static/media/Breakfast.84a20e60.jpeg";